module.exports = __webpack_public_path__ + "static/f2bdb625ebc2e2bbf75170c658a201bb1f29debc305f617049ea060c82ca100c-49509552f8f6a806078676920ac998eb.png";